import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { type ReactNode } from "react";
import { cn } from "./cn";

export const TooltipProvider = TooltipPrimitive.Provider;

interface TooltipProps {
  label: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  shortcut?: string;
  delayDuration?: number;
}

/** Accessible tooltip wrapper — wrap any focusable trigger. */
export function Tooltip({
  label,
  children,
  side = "bottom",
  shortcut,
  delayDuration = 250,
}: TooltipProps) {
  return (
    <TooltipPrimitive.Root delayDuration={delayDuration}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={6}
          className={cn(
            "z-50 max-w-xs rounded-lg border border-line-soft/80 bg-surface-3/95 px-2.5 py-1.5",
            "text-xs text-fg-strong shadow-elev2 backdrop-blur",
            "data-[state=delayed-open]:animate-fade-in",
          )}
        >
          <span className="flex items-center gap-2">
            <span>{label}</span>
            {shortcut ? (
              <kbd className="rounded border border-line-soft/80 bg-surface-2/80 px-1 py-0.5 font-mono text-[10px] text-fg-muted">
                {shortcut}
              </kbd>
            ) : null}
          </span>
          <TooltipPrimitive.Arrow className="fill-[hsl(var(--bg-surface-3)/0.95)]" />
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
